import { withDictionarySelect } from '../../../../../HOC/withDictionarySelect';
import { API } from '../../../../../api';

export const SelectGenderWrapper = withDictionarySelect(API.List.Gender);
